import { render } from "./app-header-notify.vue?vue&type=template&id=a72120ca&scoped=true"
import script from "./app-header-notify.vue?vue&type=script&lang=js"
export * from "./app-header-notify.vue?vue&type=script&lang=js"

import "./app-header-notify.vue?vue&type=style&index=0&id=a72120ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72120ca"]])

export default __exports__